import script from "./UserView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserView.vue?vue&type=script&setup=true&lang=js"

import "./UserView.vue?vue&type=style&index=0&id=0301a8e5&lang=scss"

const __exports__ = script;

export default __exports__